import React, { Component } from "react";
import { PageHeader, ListGroup, ListGroupItem, Breadcrumb } from "react-bootstrap";
import LoaderButton from "../components/LoaderButton";
import "./Trips.css";
import { Storage, API } from "aws-amplify";
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import loaderIcon from'../images/ftc_logo.gif';
import EnhancedTable from "./EnhancedTable";
import JSZip from 'jszip';
import FileSaver from 'file-saver';
import TripsCard from "./TripsCard";
import pako from "pako";



const rowHeaders = [
  { id: 'uploaded', numeric: false, center: false, disablePadding: false, label: 'Uploaded' },
  { id: 'downloaded', numeric: false, center: false, disablePadding: false, label: 'Downloaded' },
  { id: 'tripId', numeric: false, center: false, disablePadding: false, label: 'Id' }
];

export default class Trips extends Component {
  constructor(props) {
    super(props);
    const projectId = this.props.location.state && this.props.location.state.projectId;
    const projectTitle = this.props.location.state && this.props.location.state.projectTitle;
    const schemaId = this.props.location.state && this.props.location.state.schemaId;
    const version = this.props.location.state && this.props.location.state.version;
    const projectLogo = this.props.location.state && this.props.location.state.logo;
    const notes = this.props.location.state && this.props.location.state.notes;
    this.state = {
      alertOpen: false,
      version: version,
      projectId: projectId,
      projectTitle: projectTitle,
      schemaId: schemaId,
      logo: projectLogo,
      notes: notes,
      isLoading: true,
      isDownloading: false,
      isDeleting: false,
      trips: []
    };
  }
async componentDidMount() {
  //console.log(this.props);
  if (!this.props.isAuthenticated) {
    return;
  }
  if (!this.state.projectId) {
    this.props.history.push("/Projects");
    return;
  }
  try {
    const trips = await this.getOrgProjectTrips();
    const rows = await this.getStructuredTripList(trips);
    this.setState({ trips, rows });
  } catch (e) {
    alert(e);
  }

  this.setState({ isLoading: false });
}

getOrgProjectTrips() {
  if (this.props.org) {
    console.log(`/organisations/${this.props.org.pk}/projects/${this.state.projectId}/${this.state.schemaId}/trips`);
    return API.get("ftc", `/organisations/${this.props.org.pk}/projects/${this.state.projectId}/${this.state.schemaId}/trips`);
  } else {
    return API.get("ftc", `/organisations/user/projects/${this.state.projectId}/${this.state.schemaId}/trips`);
  }
}
deleteTrips() {
  const ids = this.selected;
  let orgId = 'user';
  if (this.props.org) {
    orgId = this.props.org.pk;
  }
  const body = {orgId: orgId, ids: ids};
  try {
    return API.del("ftc", "/trips", {body: body});
  }catch(e) {
    console.log(e);
  }
}

updateTrips(ids) {
  let orgId = 'user';
  if (this.props.org) {
    orgId = this.props.org.pk;
  }
  const body = {orgId: orgId, ids: ids};
  console.log(body);
  try {
    return API.put("ftc", "/trips", {body: body});
  }catch(e) {
    console.log(e);
  }
}


handleCrumbClick = event => {
  event.preventDefault();
  const href = event.currentTarget.getAttribute("href");
  if (href === "/Projects/Project") {
    this.props.history.push({
      pathname: '/projects/project',
      state: { projectId: this.state.projectId }
    });
    //this.props.history.push("/Projects/" + this.state.projectId);
  } else {
    this.props.history.push(href);
  }
}
async getStructuredTripList(trips) {
  console.log(trips);
  var rows = [];
  for (var i = 0; i < trips.length; ++i) {
    let t = trips[i];
    //const {id} = t;
    const tripId = t.sk.substring(t.sk.lastIndexOf("|")+1)
    let downloaded = '';
    if (t.downloaded) {
      downloaded = (new Date(t.downloaded)).toLocaleString();
    }
    let rowCols = [
      { id: 'uploaded', numeric: false, center: false, disablePadding: false, value: (new Date(t.updated)).toLocaleString(), type: 'date' },
      { id: 'downloaded', numeric: false, center: false, disablePadding: false, value: downloaded, type: 'date' },
      { id: 'tripId', numeric: false, center: false, disablePadding: false, value: tripId, type: 'text' },
    ];
    rows.push({id: i + 1, uploaded: t.updated, downloaded: downloaded, tripId: tripId, key: t.sk, cols: rowCols})
  }
  return rows
}


handleDownloadTripClick = async (event, selected) => {
  event.preventDefault();
  console.log(selected);
  this.selected = selected;
  this.setState({
    isDownloading: true,
  });
  this.currentTripIndex = 0;
  this.tripzip = new JSZip();
  await this.loadTrip();
}

async loadTrip() {
  let idx = this.currentTripIndex;
  if ( idx < this.selected.length) {
    let orgId = this.props.org.pk;
    let projectId = this.state.projectId;
    const tripSk = this.selected[idx];
    let tripId = tripSk.substring(tripSk.lastIndexOf("|")+1);
    let path = `${orgId}/trips/${tripId}/json/${tripId}.trp`;
    console.log(path);
    await Storage.get(path)
    .then(result => this.extractJson(result))
    .catch(err => console.log('ERR: ' + err));
  } else {
    this.saveTripZip();
    const result = await this.updateTrips(this.selected);
    console.log(result);
    const trips = await this.getOrgProjectTrips();
    const rows = await this.getStructuredTripList(trips);
    this.setState({ isDownloading: false, trips, rows });
  }
}
extractJson(compressedJson) {
  let context = this;
  var xhr = new XMLHttpRequest();
  xhr.open("GET", compressedJson, true);
  xhr.onload = function()
  {
        let binaryString = xhr.response;
        let deflatedBinaryString = window.atob(binaryString);
        let jsonString = pako.inflate(deflatedBinaryString, { to: 'string' });
        let obj = JSON.parse(jsonString);
        let t = obj.trip;
        context.trip = t;
        context.json = jsonString;
        context.currentEventIndex = 0;
        context.populateFilePaths();

  }
  xhr.send();
}

populateFilePaths() {
  let idx = this.currentEventIndex;
  let orgId = this.props.org.pk;
  let projectId = this.state.projectId;
  const tripSk = this.selected[this.currentTripIndex];
  let tripId = tripSk.substring(tripSk.lastIndexOf("|")+1);
  if (idx < this.trip.events.length) {
    if (this.trip.events[idx].type === 'CAMERA') {
      let filename = this.trip.events[idx].values.filename;
      let path = `${orgId}/trips/${tripId}/photos/${filename}`;
      Storage.get(path)
        .then(result => this.addAuthenticatedFilePath(result))
        .catch(err => console.log('ERR: ' + err));
    } else if (this.trip.events[idx].type === 'AUDIO') {
      let filename = this.trip.events[idx].values.filename;
      let path = `${orgId}/trips/${tripId}/audio/${filename}`;
      Storage.get(path)
        .then(result => this.addAuthenticatedFilePath(result))
        .catch(err => console.log('ERR: ' + err));
    } else {
      this.currentEventIndex = idx + 1;
      this.populateFilePaths();
    }
  } else {
    console.log(tripSk);
    console.log(tripId);
    var folder = this.tripzip.folder(tripId);
    folder.file("trip.json", this.json);
    this.currentEventIndex = 0;
    this.getFilesAsBlobs();
  }
}

addAuthenticatedFilePath(path) {
  let idx = this.currentEventIndex;
  if (this.trip.events[idx].type === 'CAMERA') {
    this.trip.events[idx].imagePath = path;
  } else if (this.trip.events[idx].type === 'AUDIO') {
    this.trip.events[idx].audioPath = path;
  }
  this.currentEventIndex = idx + 1;
  this.populateFilePaths();
}
getFilesAsBlobs() {
  let idx = this.currentEventIndex;
  console.log(idx, this.trip.events.length);
  if ( idx < this.trip.events.length) {
    if (this.trip.events[idx].imagePath != null) {
      this.getFileAsBlob("image/jpeg", this.trip.events[idx].imagePath);
    } else if (this.trip.events[idx].audioPath != null) {
      this.getFileAsBlob("audio/mp4", this.trip.events[idx].audioPath);
    } else {
      this.currentEventIndex = idx + 1;
      this.getFilesAsBlobs();
    }
  } else {
    this.currentTripIndex += 1;
    this.loadTrip();
  }

}
saveTripZip() {
  var title = this.state.projectTitle.split(' ').join('_') + '_v' + this.state.version;
  this.tripzip.generateAsync({type:"blob"})
  .then(function(content) {
      FileSaver.saveAs(content, title + ".zip");
  });

}


getFileAsBlob(mimeType, url) {
  console.log(url);
  let urlWithDummy = url + "&x-request=dummy"; //workaround to load in html and using get
  let context = this;
  var xhr = new XMLHttpRequest();
  xhr.open("GET", urlWithDummy, true);
  xhr.responseType = "arraybuffer";
  xhr.onload = function(e)
  {
        var arrayBufferView = new Uint8Array( this.response );
        var blob = new Blob( [ arrayBufferView ], { type: mimeType } );
        context.addFileToZip(blob);
  }
  xhr.send();
}
addFileToZip(blob) {
  console.log('addFileToZip');

  let idx = this.currentEventIndex;
  //const currentTripId = this.selected[this.state.currentTripIndex];
  const tripSk = this.selected[this.currentTripIndex];
  const currentTripId = tripSk.substring(tripSk.lastIndexOf("|")+1);
  if (this.trip.events[idx].imagePath != null) {
    var folder = this.tripzip.folder(currentTripId + "/images");
  } else if (this.trip.events[idx].audioPath != null) {
    var folder = this.tripzip.folder(currentTripId + "/audio");
  }
  var filename = this.trip.events[idx].values.filename;
  folder.file(filename, blob);
  this.currentEventIndex = idx + 1;
  this.getFilesAsBlobs();
}


handleDeleteTripClick = async (event, selected) => {
  event.preventDefault();
  let count = selected.length;
  if (count > 0) {
    this.selected = selected;
    this.setState({
      alertOpen: true
    });
  }
}
 handleDeleteTrips = async (event) => {
   console.log(this.state);
   console.log('LEN0: ', this.state.rows.length);
  this.setState({ isDeleting: true, alertOpen: false });
  console.log('aaa');
  let isSuccess = false
  try {
    const result = await this.deleteTrips();
    console.log(result);
    isSuccess = true;
  } catch (e) {
    alert(e);
  }

  console.log('ddd');
  const trips = await this.getOrgProjectTrips();
  const rows = await this.getStructuredTripList(trips);
  this.setState({ isDeleting: false, trips: trips, rows: rows });
}
handleAlertClose = () => {
    this.setState({ alertOpen: false });
};
handleTripClick = (event, tripSk) => {
  event.preventDefault();
  const tripId = tripSk.substring(tripSk.lastIndexOf("|")+1)
  this.props.history.push({
    pathname: '/projects/schemas/trips/trip',
    state: { projectTitle: this.state.projectTitle, projectId: this.state.projectId, schemaId: this.state.schemaId, tripId: tripId, version: this.state.version, logo: this.state.logo, notes: this.state.notes}
  });
}
renderLoader() {
  const label = this.state.isDownloading ? 'downloading...' : this.state.isDeleting ? 'deleting...' : 'loading...';
  return(

    <div id="splash" style={{paddingTop: 250, zIndex:999}}>

      <center id="splash">
        <img src={loaderIcon}/>
        <Typography style={{padding: '4px'}} variant="caption">{label}</Typography>
      </center>
    </div>



  )
}
renderTripsList() {
  const menuItems = [
    { id: 0, label: 'Download', lt: 1, gt: -1, isOrOperator: false, action: this.handleDownloadTripClick, divider: true, type: 'download' },
    { id: 1, label: 'Delete', lt: 1, gt: -1, isOrOperator: false, action: this.handleDeleteTripClick, divider: false, type: 'delete' }
  ];
    return (
        <div>
          {!this.state.isLoading && <EnhancedTable
                                        logosKey={this.state.key}
                                        title='Trips'
                                        tooltip=''
                                        items={this.state.rows}
                                        menuItems={menuItems}
                                        handleItemClick={this.handleTripClick}
                                        rowHeaders={rowHeaders}
                                        orderBy='uploaded'
                                        order='desc'
                                        />}
          </div>
    );
  }


  render() {
    return (
    <div>
        <Breadcrumb style={{top: 58, left: 66, right: 0, position: 'absolute', zIndex:999, backgroundColor: '#FFF'}}>
          <Breadcrumb.Item onClick={this.handleCrumbClick} href="/">Home</Breadcrumb.Item>
          <Breadcrumb.Item onClick={this.handleCrumbClick} href="/Projects">Projects</Breadcrumb.Item>
          <Breadcrumb.Item onClick={this.handleCrumbClick} href="/Projects/Project">{this.state.projectTitle + ': v' + this.state.version }</Breadcrumb.Item>
          <Breadcrumb.Item active>Trips</Breadcrumb.Item>
        </Breadcrumb>
        <div className="Trips" style={{position: 'absolute', left:80, right:80,top: 104, paddingBottom:50}}>
        {!this.state.isLoading && <TripsCard
          title={this.state.projectTitle}
          subtitle={'Schema Version ' + this.state.version}
          description={this.state.notes}
          logo={this.state.logo}
          colour={'#FAFcFA'}
          />}

          {this.state.isLoading || this.state.isDownloading || this.state.isDeleting ? this.renderLoader() : this.renderTripsList()}
        </div>
        <Dialog
            open={this.state.alertOpen}
            onClose={this.handleAlertClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">{"Delete Trips"}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                Are you sure you wish to delete the selected trips? <br/><br/>This cannot be undone.
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={this.handleAlertClose} color="secondary">
                Cancel
              </Button>
              <Button onClick={this.handleDeleteTrips} color="primary" autoFocus>
                Delete
              </Button>
            </DialogActions>
          </Dialog>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Trips.js